import { METHOD_INTRO } from '@/content/copy';
import { PIZZA_DAY_DATE, PIZZA_MODEL_LABELS } from '@/lib/constants';
import type { PizzaModelId, SeriesMeta } from '@/lib/types';

type Props = {
  meta?: SeriesMeta;
  pizzaModel: PizzaModelId;
};

export function Methodology({ meta, pizzaModel }: Props) {
  return (
    <section id="methodology" className="section methodology">
      <div className="section-head">
        <h2>Methodology & assumptions</h2>
        <p className="muted">{METHOD_INTRO}</p>
      </div>

      <div className="method-grid">
        <article className="card">
          <h3>Baseline context</h3>
          <p>
            We anchor the story at Bitcoin Pizza Day ({PIZZA_DAY_DATE}), when 10,000 BTC bought two pizzas. In this project,
            the historical baseline model uses <strong>$20 per pizza</strong> as the reference point.
          </p>
        </article>

        <article className="card">
          <h3>Active pricing model</h3>
          <p>
            Current model: <strong>{PIZZA_MODEL_LABELS[pizzaModel]}</strong>.
          </p>
          <p>
            The yearly schedule values (2010–2026) are inflation-adjusted estimates and are displayed near the chart for full transparency.
          </p>
        </article>

        <article className="card">
          <h3>Data source</h3>
          <p>{meta?.sourceAttribution ?? 'BTC/USD source metadata is loaded with chart data.'}</p>
          <p>
            Source: <a href={meta?.sourceUrl} target="_blank" rel="noreferrer">{meta?.source ?? 'Blockchain Charts API'}</a>
          </p>
        </article>

        <article className="card">
          <h3>Formula</h3>
          <ul>
            <li><code>pizzas_per_btc = btcUsd / pizzaUsd</code></li>
            <li><code>btc_per_pizza = pizzaUsd / btcUsd</code></li>
            <li><code>pizzas_for_10000_btc = 10000 * btcUsd / pizzaUsd</code></li>
          </ul>
        </article>
      </div>
    </section>
  );
}
